export { ParseWithTooltip } from './ParseWithTooltip';
